let e = {
  platform: "unknown",
  version: "unknown"
};
function r(n) {
  e = n;
}
function c() {
  return e;
}
function i(n) {
  const o = encodeURIComponent(e.platform.slice(0, 32)), t = encodeURIComponent(e.version.slice(0, 32));
  return `${n}&platform=${o}&version=${t}`;
}
function s(n) {
  if (n)
    return n.replace(/([?&]token=)[^&]*/g, "$1<redacted>");
}
export {
  i as a,
  c as g,
  s as r,
  r as s
};
//# sourceMappingURL=syncClientInfo-D4E7fbgz.js.map
